/**
 * @generated SignedSource<<2067e2f4cb391d075da4be8f76a0c25a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UnitSchoolGradeEnum = "five" | "four" | "high" | "highest" | "low" | "lowest" | "medium" | "one" | "seven" | "six" | "three" | "two" | "zero" | "%future added value";
export type UnitSchoolYearEnum = "elementary_school_3" | "elementary_school_4" | "elementary_school_5" | "elementary_school_6" | "high_school_1_2015" | "high_school_1_2022" | "high_school_2_2015" | "high_school_2_daesu_2022" | "high_school_2_mijukbun_2022" | "high_school_3_hwaktong_2022" | "high_school_3_liberal_arts_2015" | "high_school_3_mijukbun2_giha_2022" | "high_school_3_science_2015" | "middle_school_1" | "middle_school_2" | "middle_school_3" | "%future added value";
export type UnitDefaultRatingFetchQueryFormik_unitDefaultRatingQuery$variables = {
  schoolGrade: UnitSchoolGradeEnum;
  schoolYear: UnitSchoolYearEnum;
};
export type UnitDefaultRatingFetchQueryFormik_unitDefaultRatingQuery$data = {
  readonly unitDefaultRating: number;
};
export type UnitDefaultRatingFetchQueryFormik_unitDefaultRatingQuery = {
  response: UnitDefaultRatingFetchQueryFormik_unitDefaultRatingQuery$data;
  variables: UnitDefaultRatingFetchQueryFormik_unitDefaultRatingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "schoolGrade"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "schoolYear"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "schoolGrade",
        "variableName": "schoolGrade"
      },
      {
        "kind": "Variable",
        "name": "schoolYear",
        "variableName": "schoolYear"
      }
    ],
    "kind": "ScalarField",
    "name": "unitDefaultRating",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnitDefaultRatingFetchQueryFormik_unitDefaultRatingQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnitDefaultRatingFetchQueryFormik_unitDefaultRatingQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f983ca35e7920d58ada76cc2cd3a5c73",
    "id": null,
    "metadata": {},
    "name": "UnitDefaultRatingFetchQueryFormik_unitDefaultRatingQuery",
    "operationKind": "query",
    "text": "query UnitDefaultRatingFetchQueryFormik_unitDefaultRatingQuery(\n  $schoolGrade: UnitSchoolGradeEnum!\n  $schoolYear: UnitSchoolYearEnum!\n) {\n  unitDefaultRating(schoolGrade: $schoolGrade, schoolYear: $schoolYear)\n}\n"
  }
};
})();

(node as any).hash = "620b8a9975ee9b3d7182afffc48574fd";

export default node;
